import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class pedidoService {


    /******* QUERIES ******/
    async listarEstado() {
        const response = await axios
            .get(`${ERP}ventas/pedido/estado`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };    

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };    


    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async ticket58(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}ventas/pedido/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async importarRegistrados(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/importar-registrados?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ver(filter) {
        const response = await axios
            .get(`${ERP}ventas/pedido/ver?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}ventas/pedido`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}ventas/pedido`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}ventas/pedido/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async enviarCorreo(data) {
        const response = await axios
            .put(`${ERP}ventas/pedido/enviar-correo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new pedidoService();